/**
 * Jambuveda Ask Jeevak (dedicated page)
 * Same /chat backend contract as the floating widget, adapted for a
 * full-page layout. Clicking a starter prompt sends it as the first message.
 */
(function () {
  const root = document.querySelector('.jv-jp');
  if (!root) return;

  const endpoint = (root.dataset.endpoint || '').trim().replace(/\/$/, '');
  const shopUrl = (root.dataset.shopUrl || '').replace(/\/$/, '');
  const log = document.getElementById('jv-jp-log');
  const form = document.getElementById('jv-jp-form');
  const input = document.getElementById('jv-jp-input');
  const chips = root.querySelectorAll('.jv-jp__prompt-chip');

  const history = [];

  function addMsg(text, who, handle) {
    const el = document.createElement('div');
    el.className = 'jv-jp__msg jv-jp__msg--' + who;
    el.textContent = text;
    if (handle) {
      const a = document.createElement('a');
      a.className = 'jv-jp__product';
      a.href = shopUrl + '/products/' + handle;
      a.textContent = 'View ' + handle.replace(/-/g, ' ') + ' →';
      el.appendChild(a);
    }
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function typing() {
    const el = document.createElement('div');
    el.className = 'jv-jp__typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  async function sendMessage(text) {
    if (!text) return;
    addMsg(text, 'user');
    history.push({ role: 'user', content: text });
    input.value = '';
    const t = typing();

    try {
      let data;
      if (!endpoint) {
        await new Promise((r) => setTimeout(r, 700));
        data = { text: 'Thanks for sharing. (Preview mode — connect the Jeevak backend to get real answers.) A light, early dinner and warm water after meals is a good first step.', product_handle: null };
      } else {
        const res = await fetch(endpoint + '/chat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ messages: history }),
        });
        if (!res.ok) throw new Error('chat ' + res.status);
        data = await res.json();
      }
      t.remove();
      addMsg(data.text || '…', 'bot', data.product_handle);
      history.push({ role: 'assistant', content: data.text || '' });
      if (history.length > 12) history.splice(0, history.length - 12);
    } catch (err) {
      console.error('Ask Jeevak error', err);
      t.remove();
      addMsg('Jeevak is resting for a moment — please try again shortly.', 'bot');
    }
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const text = input.value.trim();
    if (text) sendMessage(text);
  });

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      sendMessage(chip.dataset.prompt);
      document.getElementById('jv-jp-input').scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();
